
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { sharedState } from '../../../../../../framework/state';
import { getResource } from '../../../../../../framework/client/resource';
import TextField from '../../../../../../framework/fields/TextField.vue';
import SelectField from '../../../../../../framework/fields/SelectField.vue';
import { PurchaseInvoiceRow } from '../../../../../../../common/application/model/PurchaseInvoiceRow';
import SwitchField from '../../../../../../framework/fields/SwitchField.vue';
import IntegerField from '../../../../../../framework/fields/IntegerField.vue';
import CurrencyAmountField from '../../../../../../framework/fields/CurrencyAmountField.vue';
import NumberField from '../../../../../../framework/fields/NumberField.vue';
import PercentageField from '../../../../../../framework/fields/PercentageField.vue';
import DateField from '../../../../../../framework/fields/DateField.vue';
import { ValidationObserver } from 'vee-validate';
import { getDatabaseOptions } from '../../../../../../framework/service/options';
import { InvoiceRowType } from '../../../../../../../common/application/model/enums/InvoiceRowType';
import TextAreaField from '../../../../../../framework/fields/TextAreaField.vue';
import VendorContractSelect from '../../../../../fields/VendorContractSelect.vue';
import { PurchaseInvoice } from '../../../../../../../common/application/model/PurchaseInvoice';
import { SplitPurchaseInvoiceRowReq } from '../../../../../../../common/application/model/api/SplitPurchaseInvoiceRowReq';
import { postSplitPurchaseInvoiceRowRequest } from '../../../../../client/purchase_invoice_client';
import { VehicleContract } from '../../../../../../../common/application/model/VehicleContract';
import { VendorContract } from '../../../../../../../common/application/model/VendorContract';
import { ApplicationResource } from '../../../../../../../common/application/enumeration/ApplicationResource';
import AutoCompleteField from '../../../../../../framework/fields/AutoCompleteField.vue';

@Component({
    components: {
        VendorContractSelect,
        TextAreaField,
        DateField,
        PercentageField,
        NumberField,
        CurrencyAmountField,
        SelectField,
        TextField,
        SwitchField,
        IntegerField,
        ValidationObserver,
        AutoCompleteField,
    },
})
export default class SplitPurchaseInvoiceRow extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.PURCHASE_INVOICE_ROW;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        purchaseInvoice: {} as PurchaseInvoice,
        row: {} as PurchaseInvoiceRow,
        invoiceRowTypeOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.row = {
            ...(await getResource<PurchaseInvoiceRow>(this.resourceType, this.id))!!,
            invoiceRowType: undefined as any as InvoiceRowType,
            description: '',
            unit: '',
            unitPrice: undefined as any as number,
            quantity: undefined as any as number,
        };
        this.local.purchaseInvoice = (await getResource<PurchaseInvoice>(
            ApplicationResource.PURCHASE_INVOICE,
            this.local.row.purchaseInvoiceId,
        ))!!;
        this.local.invoiceRowTypeOptions = await getDatabaseOptions('InvoiceRowType', this);
    }

    @Watch('local.row.vehicleContractId')
    async financingVehicleContractId(vehicleContractId: string | undefined) {
        if (vehicleContractId) {
            const vehicleContract = await getResource<VehicleContract>(
                ApplicationResource.VEHICLE_CONTRACT,
                vehicleContractId,
            );
            if (vehicleContract) {
                this.local.row = {
                    ...this.local.row,
                    vehicleRegistrationNumber: vehicleContract.vehicleRegistrationNumber ?? '',
                    smartFleetContractNumber: vehicleContract.smartFleetContractNumber,
                    vendorContractId: undefined,
                };
            }
        } else {
            this.local.row = {
                ...this.local.row,
                vehicleRegistrationNumber: '',
                smartFleetContractNumber: '',
                vendorContractId: undefined,
            };
        }
    }

    @Watch('local.row.vendorContractId')
    async financingVendorContractId(vendorContractId: string | undefined) {
        if (vendorContractId) {
            const vendorContract = await getResource<VendorContract>(
                ApplicationResource.VENDOR_CONTRACT,
                vendorContractId,
            );
            if (vendorContract) {
                this.local.row = {
                    ...this.local.row,
                    vendorContractNumber: vendorContract.contractNumber,
                };
            }
        } else {
            this.local.row = {
                ...this.local.row,
                vendorContractNumber: '',
            };
        }
    }

    async save() {
        const oldRow = (await getResource<PurchaseInvoiceRow>(this.resourceType, this.id))!!;
        const splitPurchaseInvoiceRowRequest: SplitPurchaseInvoiceRowReq = {
            newPurchaseInvoiceRow: this.local.row,
            oldPurchaseInvoiceRow: oldRow,
        };
        await postSplitPurchaseInvoiceRowRequest(splitPurchaseInvoiceRowRequest);
        this.back();
    }

    back() {
        this.$router.go(-1);
    }
}
